import { makeRequest } from '../client';

export const getActiveCampaigns = (restaurantId) =>
  makeRequest('campaign', 'getActiveCampaigns', { restaurantId });
